import { render, staticRenderFns } from "./adp-account-form.vue?vue&type=template&id=2905478c"
import script from "./adp-account-form.vue?vue&type=script&lang=js"
export * from "./adp-account-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports